import useTabs from './useTabs'
import useStartMarkingWords from './useStartMarkingWords'
import useSaveDraft from './useSaveDraft'
import useSaveComplete from './useSaveCompleted'
import useSave from './useSave'
import useHeaderActions from "./useHeaderActions";
import useActionBtns from './useActionBtns'
import useBackToConfirmation from './useBackToConfirmation'
import useInitializeConfirmation from './useInitializeConfirmation'
import useUpdateAssBtns from './useUpdateAssBtns'
import useChatMarkupState from './useChatMarkupState'
import useCloneAssessment from './useCloneAssessment'
import useCreateVersion from './useCreateVersion'
import useVersionColumns from './useVersionColumns'
import useIsTraining from './useIsTraining'
import useStartMarkingAudio from './useStartMarkingAudio'
import useMarkingAudioSaveDraft from './useMarkingAudioSaveDraft'
import useGenerateAudioAndVersion from './useGenerateAudioAndVersion'
import useAudioActionBtns from './useAudioActionBtns'
import useGetAudioNeto from './useGetAudioNeto'

export default { useAudioActionBtns, useGetAudioNeto, useGenerateAudioAndVersion, useStartMarkingAudio, useMarkingAudioSaveDraft, useVersionColumns, useIsTraining, useCloneAssessment, useCreateVersion, useChatMarkupState, useSave, useUpdateAssBtns, useSaveComplete, useInitializeConfirmation, useBackToConfirmation, useHeaderActions, useTabs, useActionBtns, useStartMarkingWords, useSaveDraft }
